import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';

@FormComponentLookup('custom-statement-auth')
@Component({
    selector: 'app-custom-statement-auth',
    templateUrl: './custom-statement-auth.component.html',
    styleUrls: ['./custom-statement-auth.component.scss'],
    standalone: false
})
export class CustomStatementAuthComponent extends FormEntryComponentClass implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() { }

}
